var $5f9f4b115dc0e870$exports = {};
const $5f9f4b115dc0e870$var$toutch = document.querySelector(".toutch--js");
const $5f9f4b115dc0e870$var$known = document.querySelector(".known--js");
const $5f9f4b115dc0e870$var$view = document.querySelector(".view--js");
const $5f9f4b115dc0e870$var$source = document.querySelector(".source--js");
const $5f9f4b115dc0e870$var$view2 = document.querySelector(".view2--js");
const $5f9f4b115dc0e870$var$source2 = document.querySelector(".source2--js");
const $5f9f4b115dc0e870$var$view3 = document.querySelector(".view3--js");
const $5f9f4b115dc0e870$var$source3 = document.querySelector(".source3--js");
const $5f9f4b115dc0e870$var$mail = document.querySelector(".mail--js");
const $5f9f4b115dc0e870$var$git = document.querySelector(".git--js");
const $5f9f4b115dc0e870$var$thing = document.querySelector(".thing--js");
const $5f9f4b115dc0e870$var$linkedin = document.querySelector(".linkedin--js");
const $5f9f4b115dc0e870$var$facebook = document.querySelector(".facebook--js");
const $5f9f4b115dc0e870$var$instagram = document.querySelector(".instagram--js");
const $5f9f4b115dc0e870$var$twitter = document.querySelector(".twitter--js");
$5f9f4b115dc0e870$var$thing.addEventListener('click', ()=>{
    alert('Error, the specified page does not exist');
});


//# sourceMappingURL=index.23d21a78.js.map
